export default function ResonantExcitationVisual() {
  return <div>field states works</div>;
}